import { fetchWrapper } from '../../utils';

export class attendence {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';


  static async getSelects(params) {
    const url = `${this.baseUrl}/attendence/getSelects`;
    return await fetchWrapper.post(url, params);
  }

  static async createAttendence(params) {
    const url = `${this.baseUrl}/attendence/create`;
    return await fetchWrapper.post(url, params);
  }

  static async getAttendence(params) {
    const url = `${this.baseUrl}/attendence/get`;
    return await fetchWrapper.post(url, params);
  }

  static async generateReportByLapse(params) {
    const url = `${this.baseUrl}/attendence/generateReportByLapse`;
    return await fetchWrapper.post(url, params);
  }


  static async generateReportBySubject(params) {
    const url = `${this.baseUrl}/attendence/generateReportBySubject`;
    return await fetchWrapper.post(url, params);
  }

}
